import { ColDef } from 'ag-grid-community';
import { SYSTEM_COLUMN_DEF } from 'FeatureModules/DataImport/utils/dataImport.constants';
import { TSystemColumns } from '../excelTable.types';
import ValidationCellRenderer from '../CellRenderers/SystemColumns/ValidationCellRenderer';

const VALIDATION_COLUMN: ColDef<TSystemColumns> = {
  ...SYSTEM_COLUMN_DEF,
  field: 'validation',
  pinned: 'left',
  cellRenderer: ValidationCellRenderer,
};

export default VALIDATION_COLUMN;
